<template>
  <div class="moments-component">
    <div class="moments-component__container">
      <div class="moments-component__gallery">
        <div class="moments-component__first-line">
          <div class="moments-component__gallery-img">
            <img src="/images/moment1.webp" alt="Travelers exploring a scenic destination" width="338" height="186" loading="lazy">
          </div>
          <div class="moments-component__gallery-img">
            <img src="/images/moment3.webp" alt="Memorable travel experience" width="237" height="186" loading="lazy">
          </div>
        </div>
        <div class="moments-component__second-line">
          <div class="moments-component__gallery-img">
            <img src="/images/moment3.webp" alt="Adventure travel moment" width="237" height="186" loading="lazy">
          </div>
          <div class="moments-component__gallery-img">
            <img src="/images/moment4.webp" alt="Dream vacation destination" width="338" height="186" loading="lazy">
          </div>
        </div>
      </div>
      <div>
        <div class="moments-component__title">
          {{t('Making Every Moment Count: Your Dream Trip Starts Here')}}
        </div>
        <div class="moments-component__description">
          <p>
            {{t('We believe that travel is about more than just seeing new places—it’s about feeling alive, connecting with the world, and creating memories that stay with you forever. Let us guide you to the destinations of your dreams, where every detail is designed to inspire and delight.')}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n()
</script>

<style lang="scss">
.moments-component {
  background-color: #0F3F3E;

  &__container {
    max-width: 1120px;
    margin: 0 auto;
    padding: 40px 0;
    display: flex;
    justify-content: space-between;
    color: #fff;
    gap: 40px;

    @media screen and (max-width: 1024px) {
      padding: 40px 16px;
    }

    @media screen and (max-width: 768px) {
      flex-direction: column;
    }
  }


  &__title {
    font-weight: 600;
    font-size: 34px;
    line-height: 44px;
    letter-spacing: 0;
    margin-bottom: 12px;
  }

  &__description {
    font-weight: 400;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 0;

    @media screen and (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &__gallery {
    width: 590px;
    min-width: 590px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media screen and (max-width: 1024px) {
      width: 523px;
      min-width: 523px;
    }

    @media screen and (max-width: 768px) {
      min-width: auto;
      width: 100%;
    }
  }

  &__first-line {
    display: flex;
    gap: 20px;
  }

  &__second-line {
    display: flex;
    gap: 20px;
  }

  &__gallery-img {
    position: relative;
    border-radius: 8px;
    height: 182px;
    overflow: hidden;

    @media screen and (max-width: 768px) {
      height: auto;
    }

    img {
      width: 100%;
      height: 182px;
      object-fit: cover;

      @media screen and (max-width: 768px) {
        height: auto;
      }
    }
  }
}
</style>
